<ul class="inspiration-items">
  <li>
    <figure (click)="selectInspiration(0)">
      <span class="media from-scratch">
        <div class="from-scratch-container">
          <svg class="icon-action-edit" aria-hidden="true">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-edit"></use>
          </svg>
          <figcaption>
            {{ 'need_mapping.storage.cta_fromScratch' | translate }}
          </figcaption>
        </div>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
    </figure>
  </li>
  <li *ngFor="let inspiration of inspirations"
      [class.active]="current.storage.inspirationId === inspiration.id">
    <figure (click)="selectInspiration(inspiration.id)">
      <span
        class="media">
        <span class="no-img" *ngIf="inspiration.mediaUrl === ''">Id:{{ inspiration.id }}</span>
        <img *ngIf="inspiration.mediaUrl !== ''" [src]="inspiration.mediaUrl"
             [alt]="inspiration.title" />
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
    </figure>
  </li>
</ul>
